import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["destroyInput"];
  static classes = ["marked"];

  connect() {
    this.isMarkedForDeletion = this.destroyInputTarget.value === "1";
    this.updateAppearance();
  }

  toggleDelete(event) {
    console.log("here");
    event.preventDefault();
    this.isMarkedForDeletion = !this.isMarkedForDeletion;
    this.destroyInputTarget.value = this.isMarkedForDeletion ? "1" : "0";
    this.updateAppearance();
  }

  updateAppearance() {
    if (this.isMarkedForDeletion) {
      this.element.classList.add(this.markedClass);
    } else {
      this.element.classList.remove(this.markedClass);
    }
  }
}
